import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ScoresApp from "@/ScoresApp";

// Variant switch. `REACT_APP_VARIANT=scores` at build time produces the
// standalone Live Scores app. Anything else (default) produces the main
// SmartKick Predictions app.
//
// Preview override: the URL query `?variant=scores` flips to the Scores
// variant ONLY for the current page load. This is non-sticky — refreshing
// to a clean URL brings back the main app. Sticky persistence proved
// unsafe (locked users into the variant across sessions).
const ENV_VARIANT = process.env.REACT_APP_VARIANT;
let URL_VARIANT = null;
if (typeof window !== "undefined") {
  try {
    const params = new URLSearchParams(window.location.search);
    URL_VARIANT = params.get("variant");
  } catch {
    /* ignore */
  }
}
const VARIANT = ENV_VARIANT || URL_VARIANT;
const RootComponent = VARIANT === "scores" ? ScoresApp : App;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RootComponent />
  </React.StrictMode>,
);
